// mixin for selecting create your own or half and half
import { halfNHalfItem } from '../../utils/const'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import slug from 'slug'

export default {
  computed: {
    ...mapGetters(['createYourOwnProduct', 'freePizzaRewardDeal', 'currentStore'])
  },
  methods: {
    ...mapActions(['setCurrentItem']),
    ...mapMutations(['clearCurrentItem']),
    selectHalfNHalf () {
      this.clearCurrentItem()
      this.setCurrentItem({ product: JSON.parse(JSON.stringify(halfNHalfItem)) })
      if (this.$platform === 'pos') {
        return this.$router.push({ path: '/ordering/menu/product/halfnhalf' })
      }
      this.$router.push({ path: '/menu/product/halfnhalf' })
    },
    selectCreateYourOwn () {
      this.clearCurrentItem()
      const cyo = Object.assign({ cartIndex: null, qty: 1 }, this.createYourOwnProduct)
      cyo.selectedSize = cyo.sizes[0]
      cyo.price = parseFloat(cyo.selectedSize.price)
      this.setCurrentItem({ product: cyo })
      if (this.$platform === 'pos') {
        return this.$router.push({ path: '/ordering/menu/product/' + slug( this.createYourOwnProduct.name) })
      }
      this.$router.push({ path: '/menu/product/' + slug( this.createYourOwnProduct.name) })
    },
    selectFreePizzaRewardDeal () {
      this.clearCurrentItem()
      if (this.freePizzaRewardDeal && this.freePizzaRewardDeal.sizes.length) {
        const freePizzaRewardDeal = Object.assign({ cartIndex: null }, this.freePizzaRewardDeal)
        freePizzaRewardDeal.qty = 1
        freePizzaRewardDeal.selectedSize = freePizzaRewardDeal.sizes[0]
        freePizzaRewardDeal.price = parseFloat(freePizzaRewardDeal.selectedSize.price)
        this.setCurrentItem({ product: freePizzaRewardDeal })
        this.redirectToDeal(this.freePizzaRewardDeal)
      }
    }
  }
}
